//components
import { Divider, Grid } from "@material-ui/core";
// style
import { makeStyles } from "@material-ui/styles";
import React from "react";
import InformationPopOver from "./InformationPopOver";

const useStyle = makeStyles((theme) => ({
  root: { marginTop: 15 },
  title: { fontSize: 12, fontWeight: "bold" },
}));

function InputHeader({ title, info }) {
  const classes = useStyle();

  return (
    <>
      <Grid container justify="space-between" className={classes.root}>
        <Grid item className={classes.title}>
          {title}
        </Grid>
        <Grid item>{info ? <InformationPopOver info={info} /> : null}</Grid>
      </Grid>
      <Divider />
    </>
  );
}

export default InputHeader;
